import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useNotification } from '@/contexts/NotificationContext';

interface EmployerRouteProps {
  children: React.ReactNode;
}

const EmployerRoute: React.FC<EmployerRouteProps> = ({ children }) => {
  const { user, profile, loading } = useAuth();
  const { showNotification } = useNotification();

  // Show notification if job seeker tries to access employer page
  useEffect(() => {
    if (!loading && user && profile?.user_type === 'job_seeker') {
      showNotification("Access requires an Employer account", 4000);
    }
  }, [loading, user, profile, showNotification]);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect to auth if not logged in
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Redirect if user is a job seeker
  if (profile?.user_type === 'job_seeker') {
    return <Navigate to="/" replace />;
  }

  // Allow access if user is an employer
  return <>{children}</>;
};

export default EmployerRoute;